exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.border-5[data-v-8f40ad9e] {\n    border-width:5px !important;\n    border-color: white;\n}\n.card[data-v-8f40ad9e] {\n    box-shadow: none !important;\n    margin-bottom: 0rem;\n}\n", ""]);

// exports
